import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';

import { CHILDREN_PROP_TYPES } from 'propTypes';

import {
  Modal,
  ModalContentsBase,
  ModalDismissButton,
  ModalDialogContent,
  RouteModalCloseButton
} from 'catering/components/Modals';
import { useIsMobile } from 'styles/hooks/mediaQueries';
import { ProductLeadTimeAlert } from 'catering/components/Modals/Alerts';
import { getPageBackgroundColor } from 'styles/helpers/getThemeStyles';
import {
  baseModalDialogContentSx,
  baseModalDialogSx
} from 'styles/sx/dialogSx';

const StyledModalDialogContent = styled(ModalDialogContent)(({ theme }) => {
  const baseDialogContentStyles =
    baseModalDialogContentSx?.['&.MuiDialogContent-root'] ?? {};

  return {
    '&.MuiDialogContent-root': {
      ...baseDialogContentStyles,
      position: 'relative',
      flexGrow: 0,
      [theme.breakpoints.up('sm')]: {
        borderRadius: 8
      }
    }
  };
});

const StyledModalContentsBase = styled(ModalContentsBase)(({ theme }) => {
  const baseDialogPaperStyles = baseModalDialogSx['& .MuiDialog-paper'] ?? {};
  return {
    '& .MuiDialog-paper': {
      ...baseDialogPaperStyles,
      width: 396,
      backgroundColor: getPageBackgroundColor(theme),
      [theme.breakpoints.down('sm')]: {
        margin: 0,
        width: '100%'
      }
    }
  };
});

export function RouteModal({
  children,
  displayDismissButton = true,
  ModalDismissButtonProps = {},
  productLeadTimeAlert = '',
  onClose,
  sx = {},
  ...rest
}) {
  const isMobile = useIsMobile();
  return (
    <Modal initialIsOpen>
      <StyledModalContentsBase
        fullScreen={isMobile}
        onClose={onClose}
        {...rest}
      >
        <StyledModalDialogContent sx={sx}>
          {displayDismissButton && (
            <ModalDismissButton>
              <RouteModalCloseButton
                onClick={onClose}
                {...ModalDismissButtonProps}
              />
            </ModalDismissButton>
          )}
          {children}
        </StyledModalDialogContent>
        <ProductLeadTimeAlert alertMessage={productLeadTimeAlert} />
      </StyledModalContentsBase>
    </Modal>
  );
}

RouteModal.propTypes = {
  children: CHILDREN_PROP_TYPES.isRequired,
  displayDismissButton: PropTypes.bool,
  ModalDismissButtonProps: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  productLeadTimeAlert: PropTypes.string,
  sx: PropTypes.object
};
